import Api from "../axios"

export const deleteApplication = (selectedId)=>{
    return Api.delete(`/delete_leave?application_id=${selectedId}`);
}
